export default {
	home: {
		name: ""
	},
	page_out_trade_no: "マーチャント注文番号",
	submit_modeling_model_file_not_ready:
		"モデルファイルはまだ準備できていません。しばらくしてから再試行するか、カスタマーサポートにお問い合わせください。"
};
